// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","screen-xs":"640px","screen-sm":"1024px","screen-md":"1366px","screen-lg":"1680px"};